import { createSelector } from 'reselect';

export const residQuotationSelector = state => state.residQuotation;

export const residQuotationProponentSelector = createSelector(residQuotationSelector, item => item.proponente);
export const residQuotationRealEstateData = createSelector(residQuotationSelector, item => item.dados_imovel);
